<template>

  <header>
      <div class="container">
        <div class="container-blue">
        <div class="row">
          <div class="logo col-sm-2">
            <router-link to="/"><img src="../assets/images/d2logo.png" alt="logo" class="img-responsive"></router-link>
          </div><!-- end col -->

          <nav class="navbar navbar-default col-sm-10">

              <!-- Brand and toggle get grouped for better mobile display -->
              <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                  <span class="sr-only">Toggle navigation</span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                </button>
              </div>
              <!-- Collect the nav links, forms, and other content for toggling -->
              <div class="collapse navbar-collapse nav-menu" id="bs-example-navbar-collapse-1">
                <ul class="nav navbar-nav">
                    <li class="dropdown hvr-underline-from-center">
                      <router-link to="/">Home</router-link>
                    </li>
                    <li class="dropdown hvr-underline-from-center">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                            Charts <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu">
                            <li><router-link to="/charts/daily">Daily pollution</router-link></li>
                            <!-- <li><router-link to="/">Monthly pollution</router-link></li> -->
                        </ul>
                    </li>
                    <li class="dropdown hvr-underline-from-center">
                      <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                        Resources <span class="caret"></span>
                      </a>
                      <ul class="dropdown-menu" >
                        <li v-for="data in fetchedData">
                        <router-link :to="'/resources'+'/'+data.attributes.slug">{{data.attributes.title}}</router-link>
                        </li>
                      </ul>
                    </li>
                    <li class="dropdown hvr-underline-from-center">
                      <router-link to="/page/about-us">
                        About Us
                      </router-link>
                    </li>
                    <li class="dropdown hvr-underline-from-center">
                      <router-link to="/register">
                        Add My Device
                      </router-link>
                    </li>
                     <li class="dropdown hvr-underline-from-center">
                      <router-link to="/request">
                        Data Request
                      </router-link>
                    </li>
                </ul>
                <div class="header_top">
                    <div class="header_social">
                        <ul>
                            <!-- <li>
                                <a target="blank" href="#">
                                    <img src="../assets/images/twitter.jpg" alt="twitter" width="15" height="12">
                                </a>
                            </li> -->
                            <li>
                                <a target="blank" href="https://www.facebook.com/drishtikathmandu/?ref=br_rs">
                                    <img src="../assets/images/facebook.jpg" alt="fb" width="9" height="16">
                                </a>
                            </li>
                            
                        </ul>
                    </div>
                </div>
              </div><!-- /.navbar-collapse -->
          </nav>
        </div><!-- end row -->
        </div><!-- end container-blue -->
      </div><!-- end container -->
  </header><!-- end header -->

</template>

<script>

import {HTTP} from '../http-common.js'
export default {
  name: 'navigation',
  data(){
    return {
      fetchedData:[]
    }

  },
  created: function(){
      this.fetchData()
  },
   methods : {
              fetchData(value='') {
                var url = 'category'
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response
                    this.loading = false
                    this.fetchedData = jsonData.data.data
                    //console.log(this.fetchedData)
                  }
                })
                .catch(e => {
                  //this.errors.push(e)
                  this.error = true
                })
              }
  },

}


</script>



// WEBPACK FOOTER //
// Navigation.vue?1aa9c53a